export const SHORTCUTS = {
  LABEL_NAVIGATION: 'COMMON_COMMON_LABEL_NAVIGATION',
  LABEL_MAIN: 'COMMON_COMMON_LABEL_MAIN',
  LABEL_FOOTER: 'COMMON_COMMON_LABEL_FOOTER',
};
